/**
 * Register site-wide PWA service worker and sync manifest link.
 *
 * @module client/lib/register-pwa
 */
import { syncPwaManifestFromLocation } from "./sync-pwa-manifest";

let registered = false;

export function registerPwaServiceWorker(): void {
  syncPwaManifestFromLocation();

  if (registered || typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  registered = true;
  void navigator.serviceWorker
    .register("/pwa-sw.js", { scope: "/" })
    .catch((err: unknown) => {
      console.warn("[pagayo] PWA service worker registration failed:", err);
    });
}
